import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  RvSortableItem,
  RvSortableService,
} from '../../services/rv-sortable.service';

@Component({
  selector: 'rv-sortable-handle',
  templateUrl: './rv-sortable-handle.component.html',
  styleUrls: ['./rv-sortable-handle.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RvSortableHandleComponent implements OnInit {
  @Input() ariaDescribedby: string = 'sortable-instructions';

  public item: RvSortableItem;
  public displayName: string;
  public isDragging = false;

  @Output() rvSortableKeydown = new EventEmitter<KeyboardEvent>();
  @Output() rvSortableBlur = new EventEmitter<void>();
  @Output() rvSortableMousedown = new EventEmitter<void>();
  @Output() rvSortableMouseup = new EventEmitter<void>();
  @Output() rvSortableMouseleave = new EventEmitter<void>();

  constructor(
    private el: ElementRef,
    @Inject(RvSortableService)
    public sortableService: RvSortableService<RvSortableItem>,
  ) {}

  ngOnInit() {
    this._setItemData();
  }

  get sortableIndex(): number {
    if (this.item) {
      return this.sortableService.config.items.findIndex(
        (item) => item.rvSortableId === this.item.rvSortableId,
      );
    }
    return -1;
  }

  private _setItemData(): void {
    // Find the index by looking at the position among rv-sortable-item siblings
    const sortableItem = this.el.nativeElement.closest('.rv-sortable-item');
    if (sortableItem) {
      const allItems =
        sortableItem.parentElement.querySelectorAll('.rv-sortable-item');
      const currentIndex = Array.from(allItems).indexOf(sortableItem);

      if (currentIndex >= 0) {
        this.item = this.sortableService.config.items[currentIndex];
        if (this.item) {
          this.displayName = this.sortableService.config.getDisplayName(
            this.item,
          );
        }
      }
    }
  }

  onKeydown(event: KeyboardEvent): void {
    if (
      this.sortableService &&
      this.item &&
      typeof this.sortableIndex === 'number'
    ) {
      this.sortableService.handleSortableKeydown(event, this.item);
    }
    this.rvSortableKeydown.emit(event);
  }

  onBlur(): void {
    if (!this.sortableService.isKeyboardMoving) {
      this.sortableService.revertKeyboardSort();
    }
    this.rvSortableBlur.emit();
  }

  onMousedown(): void {
    this.isDragging = true;
    this.rvSortableMousedown.emit();
  }

  onMouseup(): void {
    this.isDragging = false;
    this.sortableService.onDragEnd();
    this.rvSortableMouseup.emit();
  }

  onMouseleave(): void {
    if (this.isDragging) {
      this.isDragging = false;
      this.sortableService.onDragEnd();
      this.rvSortableMouseleave.emit();
    }
  }
}
